'use client';

import { useEffect, useState } from 'react';
import {
  EVENT_TRACKER_READY,
  trackerReadyInWindow,
  trackingLibTrackerReadyInWindow,
} from '../../tracking/TrackingProvider';

type UseIsTrackerReady = () => boolean;

/**
 * Check if tracker is ready.
 */
export const useIsTrackerReady: UseIsTrackerReady = () => {
  let [trackerReady, setTrackerReady] = useState(false);

  let handleTrackerReadyStateChange = () => {
    setTrackerReady(true);
  };

  useEffect(() => {
    if (trackerReadyInWindow() || trackingLibTrackerReadyInWindow()) {
      return;
    }

    window.addEventListener(EVENT_TRACKER_READY, handleTrackerReadyStateChange);

    return () => {
      window.removeEventListener(
        EVENT_TRACKER_READY,
        handleTrackerReadyStateChange,
      );
    };
  }, []);

  if (trackerReadyInWindow() || trackingLibTrackerReadyInWindow()) {
    return true;
  }

  return trackerReady;
};
